var pic1 = require('../../assets/images/facility/art/pic1.jpg');
var pic2 = require('../../assets/images/facility/art/pic2.jpg');
var pic3 = require('../../assets/images/facility/art/pic3.jpg');
var pic4 = require('../../assets/images/facility/art/pic4.jpg');
var pic5 = require('../../assets/images/facility/art/pic2.jpg');
const DataGalleryFacilityArt = [
 {    
	id: 1,
	title:"art",
    image: pic1,	    
	alt  :"art",
  },
  {    
	id: 2,
	title:"art",
    image: pic2,	    
	alt: "art",
  },
  {    
	id: 3,
	title:"art",
    image: pic3,	    
	alt: "art",
  },
  {    
	id: 4,
	title:"art",
    image: pic4,	    
	alt: "art",
  },
  {    
	id: 5,
	title:"art",
    image: pic5,	    
	alt: "art",
  },
];
export default DataGalleryFacilityArt;